import { DeliveryStatusType } from '@numeo/types-core'
import { ColorPaletteProp } from '@mui/joy'

/**
 * Human-readable labels for DeliveryStatusType
 * Uses Record type for exhaustive type checking
 */
export const DELIVERY_STATUS_LABELS: Record<DeliveryStatusType, string> = {
    [DeliveryStatusType.PENDING]: 'Pending',
    [DeliveryStatusType.EN_ROUTE]: 'En Route',
    [DeliveryStatusType.ARRIVED]: 'Arrived',
    [DeliveryStatusType.COMPLETED]: 'Completed',
    [DeliveryStatusType.CANCELLED]: 'Cancelled',
}

/**
 * MUI Joy color palette mappings for DeliveryStatusType
 */
export const DELIVERY_STATUS_COLORS: Record<DeliveryStatusType, ColorPaletteProp> = {
    [DeliveryStatusType.PENDING]: 'neutral',
    [DeliveryStatusType.EN_ROUTE]: 'primary',
    [DeliveryStatusType.ARRIVED]: 'warning',
    [DeliveryStatusType.COMPLETED]: 'success',
    [DeliveryStatusType.CANCELLED]: 'danger',
}

/**
 * Get human-readable label for a delivery status
 */
export const getDeliveryStatusLabel = (status: DeliveryStatusType): string => {
    return DELIVERY_STATUS_LABELS[status] ?? String(status)
}

/**
 * Get MUI Joy color for a delivery status
 */
export const getDeliveryStatusColor = (status: DeliveryStatusType): ColorPaletteProp => {
    return DELIVERY_STATUS_COLORS[status] ?? 'neutral'
}

/**
 * Format a DeliveryStatusType to title case (e.g., EN_ROUTE -> "En Route")
 * Fallback for unknown status values
 */
export const formatDeliveryStatus = (status: DeliveryStatusType | string): string => {
    if (status in DELIVERY_STATUS_LABELS) {
        return DELIVERY_STATUS_LABELS[status as DeliveryStatusType]
    }
    return String(status)
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase())
}
